import type { IntegrationEvent } from "../../shared/types";
import { mockEvents } from "../mocks/events";
import { getWithFallback } from "./apiClient";

export function getEvents(): Promise<IntegrationEvent[]> {
  return getWithFallback("/events", () => mockEvents);
}
